import React from 'react'

import { CircularProgress } from '@mui/material'
import { Autocomplete, type TextFieldProps } from 'mui-rff'

import { filterMaybe } from '@edge/spark/utils'

import { normalizeDashboards, useOtherUsersDashboardsQuery, type DashboardLayout } from '@edge/spark/io-dashboards'

interface Props {
    userId: string
}

const textFieldProps: Partial<TextFieldProps> = {
    fullWidth: true,
    margin: 'normal',
}

const UserDashboardSelect: React.FC<Props> = ({ userId }: Props) => {
    const { data, loading } = useOtherUsersDashboardsQuery({
        // @ts-expect-error graphql-tools isn't aware of @export
        variables: { userId },
        fetchPolicy: 'network-only',
        returnPartialData: true,
    })

    const dashboards = data?.administrator?.user?.dashboards?.filter(filterMaybe) || []
    const normalizedDashboards = normalizeDashboards(dashboards)

    const sortedDashboards = normalizedDashboards.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
        }),
    )

    return (
        <Autocomplete
            required
            size="small"
            label="Dashboard"
            name="dashId"
            loading={loading}
            options={sortedDashboards}
            // String type regression
            // https://github.com/mui/material-ui/issues/23708
            getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt.name)}
            getOptionValue={({ id }) => id}
            textFieldProps={
                loading
                    ? {
                          InputProps: {
                              endAdornment: <CircularProgress color="primary" size={20} />,
                          },
                          ...textFieldProps,
                      }
                    : textFieldProps
            }
        />
    )
}

export default UserDashboardSelect
